/* eslint-disable import/no-extraneous-dependencies */
'use client';
import { FC } from 'react';
import { styled } from '@linaria/react';
import cx from 'classnames';
import { GTMEventKey, CustomEventName, sendGTM, GTMConstants } from '@fe-cnyes/fe-common-gtm';

export interface LinkButtonProps {
  children: React.ReactElement | string;
  target?: '_self' | '_blank' | '_parent' | '_top' | 'framename';
  href?: string;
  height?: number | string;
  active?: boolean;
  order?: number;
  symbol?: string;
  name?: string;
  gaEventName?: string;
}

const BaseButton = styled.a`
  border: none;
  border-radius: 4px;
  font-size: 15px;
  cursor: pointer;
  text-decoration: none;
  height: 31px;
  line-height: 31px;
`;

const StockButton = styled(BaseButton)<{ order?: number }>`
  background-color: rgba(226, 232, 241, 0.6);
  color: black;
  padding: 0 12px;
  order: ${({ order }) => (order ? order : 'unset')};
`;

export const Stock: FC<LinkButtonProps> = ({
  children,
  href = '/',
  target = '_self',
  active = false,
  order,
  symbol = '',
  name = '',
  gaEventName = ''
}) => {
  const onClick = (symbolId: string, symbolName: string) => {
    if (symbolId && symbolName) {
      sendGTM({
        [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_QUOTE,
        [GTMEventKey.SECTION]: `${GTMConstants.SECTION_PLACEHOLDER}_${gaEventName}`,
        [GTMEventKey.CLICK_ITEM]: `${symbolId}_${symbolName}`
      });
    }
  };

  return (
    <StockButton
      href={href}
      target={target}
      className={cx({ active })}
      order={order}
      onClick={() => onClick(symbol, name)}
    >
      {children}
    </StockButton>
  );
};

export default Stock;
